import StringToColor from 'string-to-color';

export function log(text: string, topic?: string) {
  if (process.env.NODE_ENV === 'production') return;

  const logTopic: string = topic || 'Log';

  console.log(
    `%c [${topic || 'Log'}] ${text}`,
    `color: ${
      typeof StringToColor === 'function' ? StringToColor(logTopic) : 'black'
    }`
  );
}
